import type { FC } from "react";
import type { SvgIconProps } from "@mui/material";
import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import CreditCardOutlined from "@mui/icons-material/CreditCardOutlined";
import ShoppingCartOutlined from "@mui/icons-material/ShoppingCartOutlined";
import DirectionsCarOutlined from "@mui/icons-material/DirectionsCarOutlined";
import DirectionsBusOutlined from "@mui/icons-material/DirectionsBusOutlined";
import LocalTaxiOutlined from "@mui/icons-material/LocalTaxiOutlined";
import MedicalServicesOutlined from "@mui/icons-material/MedicalServicesOutlined";
import AccountBalanceOutlined from "@mui/icons-material/AccountBalanceOutlined";
import LocalMallOutlined from "@mui/icons-material/LocalMallOutlined";
import TheaterComedyOutlined from "@mui/icons-material/TheaterComedyOutlined";
import CardGiftcardOutlined from "@mui/icons-material/CardGiftcardOutlined";
import HelpOutlineOutlined from "@mui/icons-material/HelpOutlineOutlined";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import ShieldOutlined from "@mui/icons-material/ShieldOutlined";
import SmartphoneOutlined from "@mui/icons-material/SmartphoneOutlined";
import RestaurantOutlined from "@mui/icons-material/RestaurantOutlined";
import LocalCafeOutlined from "@mui/icons-material/LocalCafeOutlined";
import WineBarOutlined from "@mui/icons-material/WineBarOutlined";
import CheckroomOutlined from "@mui/icons-material/CheckroomOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import ChairOutlined from "@mui/icons-material/ChairOutlined";
import MedicationOutlined from "@mui/icons-material/MedicationOutlined";
import FaceRetouchingNaturalOutlined from "@mui/icons-material/FaceRetouchingNaturalOutlined";
import FitnessCenterOutlined from "@mui/icons-material/FitnessCenterOutlined";
import BeachAccessOutlined from "@mui/icons-material/BeachAccessOutlined";
import FlightOutlined from "@mui/icons-material/FlightOutlined";
import PaletteOutlined from "@mui/icons-material/PaletteOutlined";
import LocalBarOutlined from "@mui/icons-material/LocalBarOutlined";
import FavoriteBorderOutlined from "@mui/icons-material/FavoriteBorderOutlined";
import WorkIcon from "@mui/icons-material/Work";
import TrendingUpOutlined from "@mui/icons-material/TrendingUpOutlined";
import PaymentsOutlined from "@mui/icons-material/PaymentsOutlined";
import MoveToInboxOutlined from "@mui/icons-material/MoveToInboxOutlined";
import WorkOutlineOutlined from "@mui/icons-material/WorkOutlineOutlined";

export const ICON_MAP: Record<string, FC<SvgIconProps>> = {
  "🏠": HomeOutlined,
  "🏡": HomeOutlined,
  "💡": LightbulbOutlined,
  "🛡️": ShieldOutlined,
  "🛡": ShieldOutlined,
  "📱": SmartphoneOutlined,
  "🏛️": AccountBalanceOutlined,
  "🏛": AccountBalanceOutlined,
  "🛒": ShoppingCartOutlined,
  "🍽️": RestaurantOutlined,
  "🍽": RestaurantOutlined,
  "☕": LocalCafeOutlined,
  "🍷": WineBarOutlined,
  "🚗": DirectionsCarOutlined,
  "🚌": DirectionsBusOutlined,
  "🚕": LocalTaxiOutlined,
  "👕": CheckroomOutlined,
  "📚": MenuBookOutlined,
  "🪑": ChairOutlined,
  "🛍️": LocalMallOutlined,
  "🛍": LocalMallOutlined,
  "🏥": MedicalServicesOutlined,
  "💊": MedicationOutlined,
  "💄": FaceRetouchingNaturalOutlined,
  "🏋️": FitnessCenterOutlined,
  "🏋": FitnessCenterOutlined,
  "🎭": TheaterComedyOutlined,
  "🏖️": BeachAccessOutlined,
  "🏖": BeachAccessOutlined,
  "✈️": FlightOutlined,
  "✈": FlightOutlined,
  "🎨": PaletteOutlined,
  "🍸": LocalBarOutlined,
  "🎁": CardGiftcardOutlined,
  "❤️": FavoriteBorderOutlined,
  "❤": FavoriteBorderOutlined,
  "💰": WorkIcon,
  "📈": TrendingUpOutlined,
  "🏦": AccountBalanceOutlined,
  "💵": AttachMoneyOutlined,
  "💸": PaymentsOutlined,
  "📥": MoveToInboxOutlined,
  "🎓": SchoolOutlined,
  "💼": WorkOutlineOutlined,
  "❓": HelpOutlineOutlined,
  "💳": CreditCardOutlined,
  "🔄": AccountBalanceOutlined,
};

interface Props {
  emoji: string | null;
  size?: number;
  color?: string | null;
}

const BudgetCategoryIcon: FC<Props> = ({ emoji, size = 20, color }) => {
  if (!emoji) return null;

  const iconColor = color || "rgb(var(--color-secondary))";
  const IconComponent = ICON_MAP[emoji];

  if (!IconComponent) {
    if (color) {
      return (
        <span
          className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[11px] leading-none"
          style={{ backgroundColor: color }}
        >
          {emoji}
        </span>
      );
    }
    return (
      <span className="flex-shrink-0 text-base leading-none">{emoji}</span>
    );
  }

  return (
    <IconComponent
      sx={{ fontSize: size, color: iconColor }}
      className="flex-shrink-0"
    />
  );
};

export default BudgetCategoryIcon;
